import { Controller } from 'stimulus';

// Click-to-dismiss banner. Persists the dismissal in localStorage under
// the key passed via `data-dismissible-key`. On reconnect, if the key is
// set, the element is hidden on load.
export default class extends Controller {
  connect() {
    const key = this.element.dataset.dismissibleKey;
    if (!key) return;
    try {
      if (localStorage.getItem(key) === '1') {
        this.element.classList.add('is-dismissed');
      }
    } catch (_) { /* localStorage unavailable, no-op */ }
  }

  dismiss(event) {
    event.preventDefault();
    const key = this.element.dataset.dismissibleKey;
    this.element.classList.add('is-dismissed');
    if (key) {
      try { localStorage.setItem(key, '1'); } catch (_) { /* no-op */ }
    }
  }
}
